import styled, { createGlobalStyle, keyframes } from 'styled-components'
import FlexBox from '../common/FlexBox'
import zIndex from '../../utils/zIndexScale'

export const MobileWrap = styled.div`
  display: none;
  background: #12161c;
  @media (max-width: 768px) {
    display: block;
  }
  .scrollContainer {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
  }
`

export const DesktopWrap = styled.div`
  height: 100%;
  @media (max-width: 768px) {
    display: none;
  }
`

export const MobileContent = styled.div`
  padding: 10px 12px;
  border-top: 1px solid #000;
  position: relative;
  top: 44px;
  background: #12161c;
`

export const MobileTitle = styled(FlexBox)`
  justify-content: space-between;
  font-size: 20px;
  padding: 10px 0;
  color: #fff;
  align-items: center;
`

export const ButtonTabs = styled.div`
  margin-top: 10px;
  font-size: 16px;
  background: #12161c;
  padding: 0 12px;
  z-index: ${zIndex.fixedTab};
  min-width: 320px;
  position: relative;
  border-bottom: 1px solid #000;
  height: 35px;
  line-height: 35px;
  display: none;
  .tab {
    color: #fff;
    width: 50px;
    text-align: left;
    transition: all 0.2s ease-in;
    margin-right: 30px;
    user-select: none;
  }

  .tab.on {
    color: #f0b90b;
    font-weight: 600;
  }

  .tab-scrollbar {
    position: absolute;
    bottom: 1px;
    left: 10px;
    background: #f0b90b;
    height: 2px;
    width: 50px;
    transition: all 200ms ease-in-out;
  }

  .tab:nth-of-type(1).on ~ .tab-scrollbar {
    transform: translate3d(0, 0, 0);
  }

  .tab:nth-of-type(2).on ~ .tab-scrollbar {
    transform: translate3d(75px, 0, 0);
  }

  @media (max-width: 768px) {
    display: flex;
  }
`

export const GlobalStyle = createGlobalStyle`
  html {
    background: #12161C ;
  }
  body {
    background-color: #12161C !important;
  }
`

export const SlideRight = keyframes`
  0%{
    transform: translateX(100%);
  }
  40%{
    transform: translateX(50%);
  }
  100%{
    transform: translateX(0%);
  }
`

export const TabContent = styled.div`
  display: none;
  position: relative;
  width: 100%;
  flex-direction: column;
  min-width: 320px;
  background: ${({ theme }) => theme.exchangeSecondBg};
  @media (max-width: 768px) {
    display: ${({ show }) => (show ? 'block' : 'none')};
  }
`

export const MobileNoData = styled.div`
  margin-top: 150px;
  position: relative;
  img {
    transform: translateX(-50%);
    position: absolute;
    left: 50%;
  }
`

export default MobileWrap
